import { AxiosPromise, AxiosStatic } from "axios";
import { TReschedule, TSimpleMessage } from "../../types";
import scheduleNotifications from "../../requests/scheduleNotifications";
import unscheduledNotifications from "../../requests/unscheduledNotifications";

const reschedule =
  (serverURL: string, appAxios: AxiosStatic, token: string) =>
  async ({
    authUserId,
    namespace,
    templateId,
    properties,
    dealId,
    dueAt,
  }: TReschedule): AxiosPromise<TSimpleMessage> => {
    const unscheduledRequest = unscheduledNotifications(
      serverURL,
      appAxios,
      token
    );

    const unscheduledResponse = await unscheduledRequest({
      authUserId,
      namespace,
      templateId,
      dealId,
    });

    if (dueAt) {
      const scheduleRequest = scheduleNotifications(serverURL, appAxios, token);

      return await scheduleRequest({
        authUserId,
        namespace,
        notifications: [
          {
            templateId,
            properties,
            dueAt,
            dealId,
          },
        ],
      });
    }
    return unscheduledResponse;
  };

export default reschedule;
